// keepalive is opt-in: requests share a 64KB per-origin quota, so only logs
// that must survive a page unload (e.g. right before a recovery reload) set it.
export function logCartEvent(event, details, level = 'warn', { keepalive = false } = {}) {
  const errorMessage = details?.error?.message || undefined;

  fetch('/api/logs', {
    method: 'POST',
    keepalive,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message: { event, details, errorMessage },
      status: level,
      ddtags: 'cart_operations',
    }),
  }).catch(() => {});
}
